import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { OverviewService } from '../service/overview.service';


@Component({
  selector: 'app-edit-overview',
  templateUrl: './edit-overview.component.html',
  styleUrls: ['./edit-overview.component.scss']
})
export class EditOverviewComponent implements OnInit {
  website: string;
  originalWebsite: string;
  isLoading = false;
  airportID: number;
  formGroup: FormGroup;
  selectedWebsite: string;

  constructor(private _matDialogRef: MatDialogRef<EditOverviewComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _overviewService: OverviewService) {
    this.website = data.website || '';
    this.airportID = data.airportID;
    this.originalWebsite = data.website || '';
    this.selectedWebsite = this.website;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      website: new FormControl(this.selectedWebsite, [Validators.maxLength(120),
        Validators.pattern(
'^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$'
        )])
    });
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.website = this.formGroup.get('website').value;
      res = await this._overviewService.putOverview(this.airportID, this.website);
      // Object.assign(this.fuel, BusinessFuel.parse(res));
      this.close({cancelBtnClicked: false, success: true, website: this.website});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      this.website = this.originalWebsite;
    }
    this._matDialogRef.close(data);
  }

}
